import { logout } from './loginService'
import CryptoJS from 'crypto-js'

export default {
    handleAuthorization,
    handleOkResponseJson,
    handleError,
    handlePreConfirmResponseJson,
    handleBadRequest400,
    criptografar,
}

const key = '82f2ceed4c503896c8a291e560bd4325'
const iv = 'sinasinasisinaaa'

export const handleAuthorization = (response) => {
    if (response.status === 401) {
        logout();
        location.reload();
        return;
    }
    return response;
}

export const handleError = (response) => {
    if (!response.ok)
        return Promise.reject(response.text());
}

export const handleOkResponseJson = async (response) => {
    if (response.ok) {
        const data = await response.json();
        return { status: response.status, data };
    }
    else if (response.status === 404) {
        return { status: 404, data: null };
    }
    else if (response.status === 400) {
        const data = await readResponsePayload(response);
        return {
            status: 400,
            data,
            message: extractApiMessage(data) || "Requisicao invalida"
        };
    }
    else if (response.status === 500) {
        const data = await readResponsePayload(response);

        return {
            status: 500,
            data,
            message: extractApiMessage(data) || "Ocorreu um erro interno",
            detalhe: data?.detail || data?.Detail || null
        };
    }
    else {
        return Promise.reject(response.text());
    }
}

const readResponsePayload = async (response) => {
    const contentType = response.headers.get('Content-Type') || '';
    if (contentType.includes('application/json')) {
        return await response.json();
    }

    return await response.text();
}

const extractApiMessage = (data) => {
    if (!data) {
        return "";
    }

    if (typeof data === "string") {
        return data;
    }

    return data.message || data.Message || data.error || data.Error || "";
}

export const handlePreConfirmResponseJson = (response) => {
    if (response.ok)
        return { status: true };
    if (response.status === 401)
        return { status: false, message: response.message };

    return response.json();
}
export const handleBadRequest400 = (response) => {
    if (response.status === 400)
        return response.json();
}

export function criptografar(senha) {
    try {
        const cipher = CryptoJS.AES.encrypt(senha, CryptoJS.enc.Utf8.parse(key), {
            iv: CryptoJS.enc.Utf8.parse(iv),
            mode: CryptoJS.mode.CBC
        })

        return cipher.toString()
    } catch (e) {
        alert(e.message);
    }
}

export const apiFetch = async (url, options = {}, timeout = 45000) => {
    const controller = new AbortController();

    const timeoutId = setTimeout(() => {
        controller.abort();
    }, timeout);

    try {
        const response = await fetch(`${url}`, {
            ...options,
            signal: controller.signal,
            headers: {
                'Content-Type': 'application/json',
                ...(options.headers || {})
            }
        });

        const authorizedResponse = handleAuthorization(response);

        if (!authorizedResponse) {
            return {
                status: 401,
                message: "Sessão expirada. Faça login novamente."
            };
        }

        return await handleOkResponseJson(authorizedResponse);
    } catch (error) {
        if (error.name === "AbortError") {
            return {
                status: 408,
                message: "A operação demorou muito para responder. Verifique sua conexão e recarregue a página para conferir se a operação não foi concluída."
            };
        }
        return {
            status: 0,
            message: "Falha de comunicação com o servidor. Verifique sua conexão e tente novamente."
        };
    } finally {
        clearTimeout(timeoutId);
    }
};
